"use client";

import { useState, useEffect } from "react";
import { useSearchParams } from "next/navigation";
import { WORK_ITEMS } from "@/lib/content/work";
import { MEDICAL_SERVICE_CONFIG } from "@/lib/content/service-configs";
import {
  filterAndSortWork,
  WORK_CATEGORY_DESCRIPTIONS,
} from "@/lib/work/work-page";
import WorkCard from "@/components/cards/WorkCard";
import WorkFilters from "@/components/WorkFilters";
import { TestimonialsSection } from "@/components/sections/TestimonialsSection";
import NdaWorkCard from "@/components/work/NdaWorkCard";
import WorkCategoryCallout from "@/components/work/WorkCategoryCallout";

export default function WorkPageClient() {
  const searchParams = useSearchParams();
  const [activeCategory, setActiveCategory] = useState("all");

  useEffect(() => {
    const category = searchParams.get("category");
    if (category) {
      setActiveCategory(category);
    }
  }, [searchParams]);

  const displayWork = filterAndSortWork(WORK_ITEMS, activeCategory);

  return (
    <div className="container mx-auto px-4 md:px-6">
      <section className="pt-2 md:pt-4">
        <div className="grid md:grid-cols-12 gap-8 items-center">
          <div className="md:col-span-5">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-medium mb-6">
              Our Work
            </h1>
            <div className="text-lg md:text-xl text-gray-600 dark:text-gray-300 mt-2 max-w-xl">
              <p>
                {WORK_CATEGORY_DESCRIPTIONS[activeCategory] ??
                  WORK_CATEGORY_DESCRIPTIONS.all}
              </p>
            </div>
          </div>
          <div className="md:col-span-7 flex justify-end md:self-center">
            <WorkFilters
              activeCategory={activeCategory}
              onCategoryChange={setActiveCategory}
            />
          </div>
        </div>
      </section>

      <div className="py-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {displayWork.map((item) => (
          <WorkCard key={item.id} {...item} />
        ))}

        {activeCategory === "medical-devices" && (
          <>
            {[...Array(2)].map((_, index) => (
              <NdaWorkCard key={`nda-${index}`} />
            ))}
          </>
        )}
      </div>

      {activeCategory === "ai-consulting" && (
        <WorkCategoryCallout
          title="We Built a Thing"
          description="Stay updated on our latest AI experiments, prototypes, and rapid builds. From concept to working product in record time."
          ctaHref="/newsletter"
          ctaLabel="Subscribe to Newsletter"
        />
      )}

      {activeCategory === "medical-devices" &&
      MEDICAL_SERVICE_CONFIG.ndaMessage ? (
        <WorkCategoryCallout
          title={MEDICAL_SERVICE_CONFIG.ndaMessage.title}
          description={MEDICAL_SERVICE_CONFIG.ndaMessage.description}
          ctaHref={MEDICAL_SERVICE_CONFIG.ndaMessage.ctaHref}
          ctaLabel={MEDICAL_SERVICE_CONFIG.ndaMessage.ctaText}
          className="!bg-tan/20 text-neutral-900 ring-1 ring-black/[0.06] dark:!bg-zinc-950/72 dark:text-zinc-100 dark:ring-white/10"
        />
      ) : null}

      {/* Testimonials Section for Digital Growth */}
      {activeCategory === "digital-experiences" && (
        <div className="my-12">
          <TestimonialsSection />
        </div>
      )}
    </div>
  );
}
